module.exports = __webpack_public_path__ + "assets/img/xiangyoujiantou.93d296be.svg";